'use strict';

class MatriculasController {
  constructor($rootScope, DataService, Storage, SidenavFactory, $state, Loading, Message) {
    'ngInject';
    this.DataService = DataService;
    this.Storage = Storage;
    this.SidenavFactory = SidenavFactory;
    this.$state = $state;
    this.Loading = Loading;
    this.Message = Message;
    this.$rootScope = $rootScope;
    this.$rootScope.auth = false;
  }

  $onInit() {
    this.getMatriculas();
  }

  getMatriculas() {
    this.Loading.show('Cargando datos.', true);
    this.DataService.get(`empresas/${this.Storage.getUser().nit}/matriculas`).then( response => {
      this.Loading.hide();
      if (response) {
        if (response.datos.length === 1000) {
          this.cargarDatosMatricula(response.datos[0]);
        } else {
          this.matriculas = response.datos;
        }
      }
    });
  }

  cargarDatosMatricula(matricula) {
    const empresa = Object.assign(this.Storage.getUser(), {
      matricula: matricula.IdMatricula,
      username: matricula.RazonSocial,
    });
    this.Storage.setUser(empresa);
    this.SidenavFactory.setUser(empresa);
    this.$rootScope.auth = true;
    this.$state.go('pendientes');
  }

  actualizarMatriculas() {
    let user = this.Storage.getUser(user);
    this.DataService.put(`empresas/${user.nit}/matriculas`,{nit:user.nit}).then((resp)=>{
      if(resp && resp.finalizado) {
        this.Message.success(resp.mensaje);
        this.matriculas = resp.datos;
      }
    });
    this.actualizado = true;
  }

}

export default MatriculasController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/matriculas/matriculas.controller.js